import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import Dialog from '../dialog';
import Button from '../button';

interface ConfirmationDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    confirmationTitle?: string;
    primary?: boolean;
    description: string;
    title?: string;
}

const ConfirmationDialog = ({
    isOpen,
    onClose,
    onConfirm,
    description,
    confirmationTitle,
    primary,
    title,
}: ConfirmationDialogProps) => {
    const { t } = useTranslation();

    return (
        <Dialog
            isOpen={isOpen}
            title={title ?? t('are-you-sure')}
            onClose={onClose}
            fullScreenOnMobile
            data-testid='confirmation-dialog'
        >
            <Box
                sx={{
                    maxWidth: '330px',
                }}
            >
                <Typography color='common.grey1'>{description}</Typography>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '16px',
                        marginTop: '24px',
                    }}
                >
                    <Button label={t('cancel')} size='large' variant='outlined' onClick={onClose} />
                    <Button
                        label={confirmationTitle ? confirmationTitle : t('delete')}
                        size='large'
                        variant={primary ? 'primary' : 'danger'}
                        onClick={onConfirm}
                    />
                </Box>
            </Box>
        </Dialog>
    );
};

export default ConfirmationDialog;
